import React from "react";

interface Props {
    className?: string,
}

const QIconCheck: React.FC<Props> = ({ className }) => {
    return (
        <i className={`fa fa-check-circle-o ${className}`} aria-hidden="true" />
    )
}

export default QIconCheck
